<template>
	<div class="custom-list">
		<CFullEmpty v-if="emptyData" class="empty-box" />
		<template v-else>
			<div v-for="(item, index) in tabData" :key="index" class="custom-item" @click="() => handleCustom(item)">
				<div class="custom-item-content">
					<p class="custom-title van-multi-ellipsis--l2">
						{{ item.subject }}
					</p>
					<p class="custom-time font-Regular">{{ item.contentTime }}</p>
				</div>
				<van-image class="custom-item-image" :class="getCoverClass" fit="cover" :src="item.logoUrl"></van-image>
			</div>
		</template>
		<CFooterLoad ref="footerLoadObs" :more="hasMore" @load-more="loadMoreData" />
	</div>
</template>

<script>
import { Image as VanImage } from 'vant';
import { irstore } from '@/fetch/interface';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import CFooterLoad from '@/view/enterprise/components/c-footer-load.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import paginationMixin from '@/view/enterprise/mixins/paginationMixin';
import { getLanguageType } from '@/assets/js/i18n';
import { useCustomCore } from '@rebuild/materials/shared/custom/context';

export default {
	components: {
		CFooterLoad,
		CFullEmpty,
		VanImage
	},
	mixins: [paginationMixin],
	props: {
		storeData: {
			type: Object,
			default: () => {
				return {};
			}
		},
		moduleId: {
			type: String,
			default: ''
		},
		moduleCoverType: {
			type: Number,
			default: 43
		}
	},
	data() {
		return {};
	},
	computed: {
		getCoverClass() {
			const type = this.moduleCoverType || 43;
			const coverMap = {
				43: 'cover--43',
				169: 'cover--169',
				21: 'cover--21'
			};
			return coverMap[type];
		},
		getModuleId() {
			return this.getRealModuleId(this.moduleId);
		}
	},
	mounted() {
		// install mixins
		this.PAGINATION_LOAD = this.loadModule;
		this.PAGINATION_OBS_INSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.install();
		};
		this.PAGINATION_OBS_UNINSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.uninstall();
		};
	},
	methods: {
		loadMoreData() {
			this.PAGINATION_LOAD_MORE();
		},
		refreshModule(query) {
			this.PAGINATION_REFRESH(query);
		},
		loadModule() {
			const { id } = this.storeData;
			return this.$axios
				.get(irstore.getCustomModuleContent(id), {
					moduleId: this.getModuleId,
					pageStart: this.pageStart,
					pageNum: 20,
					languageType: getLanguageType()
				})
				.then(res => {
					const result = (res?.rows || []).map((item, i) => {
						if (item.contentTime) item.contentTime = item.contentTime.slice(0, 10);
						return item;
					});
					this.PAGINATION_DATA_UPDATE(result);
					this.$emit('refresh');

					const total = res?.total || 0;
					const hasMore = this.tabData.length < total;
					return Promise.resolve(hasMore);
				})
				.catch(() => Promise.resolve(false));
		},
		handleCustom(item) {
			this.viewModule('custom', item);
		}
	},
	setup() {
		const { viewModule } = useModuleNavigation();
		const { getRealModuleId } = useCustomCore();
		return {
			viewModule,
			getRealModuleId
		};
	}
};
</script>

<style lang="less" scoped>
.custom-list {
	background: #f7f7f7;

	.empty-box {
		padding: 0.2rem 0;
	}

	.custom-item {
		background: #ffffff;
		padding: 0.16rem 0.14rem;
		display: flex;

		& + .custom-item {
			margin-top: 0.08rem;
		}
		&-content {
			flex: 1;
			width: 0;
			position: relative;
			.custom {
				&-title {
					font-size: 0.15rem;
					color: #12121a;
					line-height: 0.21rem;
				}
				&-summary {
					font-size: 0.12rem;
					margin-top: 0.04rem;
					line-height: 0.16rem;
					color: #a5a5a5;
				}
				&-time {
					position: absolute;
					bottom: 0;
					color: #4a4a4a;
					font-size: 0.11rem;
					line-height: 0.15rem;
				}
			}
		}
		&-image {
			margin-left: 0.12rem;
			height: 0.84rem;
			border-radius: 0.04rem 0.06rem 0.06rem 0.06rem;
			overflow: hidden;

			&.cover--43 {
				width: 1.11rem;
			}
			&.cover--169 {
				width: 1.49rem;
			}
			&.cover--21 {
				width: 1.67rem;
			}
		}
	}
}
</style>
